var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_5601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09092 13.9312V6.75637L1.93409 4.72071L0 3.59106V12.665C0 13.3656 0.550195 13.9312 1.2273 13.9312H4.09092Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 13.9311H16.7728C17.4519 13.9311 18.0001 13.3634 18.0001 12.6649V3.59106L15.8094 4.88494L13.9092 6.7563V13.9311Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09085 6.75632L3.79736 3.95292L4.09085 1.26978L8.99993 5.0682L13.909 1.26978L14.2373 3.80805L13.909 6.75632L8.99993 10.5547L4.09085 6.75632Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 1.2697V6.75625L18.0001 3.59094V1.90274C18.0001 0.336993 16.2676 -0.555598 15.0547 0.383418L13.9092 1.2697Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59073L1.88149 5.04659L4.09092 6.75604V1.26949L2.94539 0.383207C1.73039 -0.555881 0 0.336782 0 1.90246V3.59066V3.59073Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_5601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.6542b901c115581a5f7b4e178cfc906f.svg";
export { ForwardRef as ReactComponent };